export const FB_SDK_READY = 'FB_SDK_READY';

export function fbSdkReady(isFbSdkReady) {
  return {
    type: FB_SDK_READY,
    isFbSdkReady
  };
}
